function CostaRica({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_985)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.0048 10.4355H0.995188C0.352063 12.1689 0 14.0436 0 16.0007C0 17.9579 0.352063 19.8326 0.995188 21.5659H31.0049C31.648 19.8326 32 17.9579 32 16.0007C32 14.0436 31.648 12.1689 31.0048 10.4355Z" fill="#D80027"/>
  <path d="M16 0C11.1506 0 6.8054 2.15775 3.87122 5.56519H28.1288C25.1947 2.15775 20.8495 0 16 0Z" fill="#0052B4"/>
  <path d="M28.1288 26.4355H3.87122C6.8054 29.843 11.1506 32.0007 16 32.0007C20.8495 32.0007 25.1947 29.843 28.1288 26.4355Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default CostaRica;
